// SPA build-time configuration (Vite env). Only VITE_CONVEX_URL is required;
// everything else has a keyless default.

const read = (v: string | undefined): string | undefined => (v && v.trim() !== '' ? v.trim() : undefined);

export const CONVEX_URL = read(import.meta.env.VITE_CONVEX_URL as string | undefined);

/** Optional MapTiler key: swaps the keyless OpenFreeMap style for MapTiler Streets. */
export const MAPTILER_KEY = read(import.meta.env.VITE_MAPTILER_KEY as string | undefined);

/** Base style. OpenFreeMap "liberty" ships a `building-3d` fill-extrusion layer. */
export const MAP_STYLE_URL = MAPTILER_KEY
  ? `https://api.maptiler.com/maps/streets-v2/style.json?key=${encodeURIComponent(MAPTILER_KEY)}`
  : 'https://tiles.openfreemap.org/styles/liberty';

/** OSRM base for the drive mode's snap-to-road (`/nearest`). The public demo allows ≤ 1 req/s; we use 0.5. */
export const ROUTER_URL = (read(import.meta.env.VITE_ROUTER_URL as string | undefined) ?? 'https://router.project-osrm.org').replace(/\/$/, '');
